import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Cookies.css'
const Cookies = () => {
    const [showBanner, setShowBanner] = useState(false);
    const navigate=useNavigate();
    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
          setShowBanner(true);
        }
      }, []);

      const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowBanner(false);
      };

      const handleClick=()=>{
        navigate('/privacy-and-cookie-policy')
      }

  return (
    showBanner && (
        <div className='cookies'>
          <p>
            This site uses cookies to improve your experience. By using this site, you accept our .
            <span className='cookies-policy-link' onClick={handleClick}>privacy policy</span>
        </p>
          <button onClick={acceptCookies} className='btn btn-warning'>Accept</button>
        </div>
      )
  )
}

export default Cookies
